// Money + date helpers shared across the UI.

export function fmtMoney(cents, currency = 'EUR', locale = 'de-DE') {
  if (cents === null || cents === undefined) return '—';
  return new Intl.NumberFormat(locale, { style: 'currency', currency })
    .format((cents || 0) / 100);
}

export function fmtDate(isoOrYmd, locale = 'de-DE') {
  if (!isoOrYmd) return '—';
  const d = new Date(isoOrYmd);
  if (isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(d);
}

export function fmtDateTime(iso, locale = 'de-DE') {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(d);
}

export const STATUS_BADGE = {
  draft:     { variant: 'secondary', label: 'Entwurf' },
  issued:    { variant: 'primary',   label: 'Ausgestellt' },
  paid:      { variant: 'success',   label: 'Bezahlt' },
  overdue:   { variant: 'warning',   label: 'Überfällig' },
  cancelled: { variant: 'danger',    label: 'Storniert' }
};

export const REF_KIND_LABEL = {
  saas_org:   'SaaS-Organisation',
  saas_unit:  'SaaS-Einheit',
  on_premise: 'On-Premise-Installation',
  edge_box:   'Edge-Box',
  unknown:    'Unbekannt'
};

export const PAYMENT_METHOD_LABEL = {
  bank_transfer: 'Überweisung',
  sepa:          'SEPA-Lastschrift',
  credit_card:   'Kreditkarte',
  cash:          'Bar',
  paypal:        'PayPal',
  other:         'Sonstiges'
};
